module.exports = __webpack_public_path__ + "static/media/unlock.f9deff3f.svg";